import { faInfoCircle, faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useRef, useState } from 'react';
import {
  Badge,
  Button,
  Form,
  Modal,
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap';

const ServiceGroupRegistrationModal = ({
  showModal,
  handleClose,
  handleSubmit
}) => {
  const initialState = {
    name: '',
    daysToAutoClose: 1,
    actionOnCompletedReply: 'REOPEN',
    actionOnClosedReply: 'CREATE_NEW_TICKET'
  };
  const [body, setBody] = useState(initialState);
  const [validated, setValidated] = useState(false);
  const form = useRef(null);

  useEffect(() => {
    if (showModal) {
      setBody(initialState);
      setValidated(false);
    }
  }, [showModal]);

  const onSubmit = e => {
    if (form.current.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      setValidated(true);
    } else {
      setValidated(false);
      handleSubmit(body);
      setBody(initialState);
    }
  };

  return (
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Novo grupo de serviço</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form validated={validated} ref={form}>
          <Form.Group className="mb-3" controlId="serviceGroup.name">
            <Form.Label>
              Nome <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              required
              type="text"
              placeholder="Nome"
              autoFocus
              value={body.name}
              onChange={e =>
                setBody(prevBody => ({ ...prevBody, name: e.target.value }))
              }
            />
            <Form.Control.Feedback>Muito bom!</Form.Control.Feedback>
            <Form.Control.Feedback type="invalid">
              Insira um nome.
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3" controlId="serviceGroup.daysToAutoClose">
            <Form.Label>
              Dias para fechar o ticket{' '}
              <OverlayTrigger
                overlay={
                  <Tooltip>
                    Após o ticket ser fechado, não será possível reabrir,
                    adicionar anexos, notas ou realizar qualquer ação sobre ele.
                  </Tooltip>
                }
              >
                <span>
                  <FontAwesomeIcon icon={faInfoCircle} />
                </span>
              </OverlayTrigger>{' '}
              <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              required
              type="number"
              placeholder="Dias para fechar o ticket"
              min={1}
              value={body.daysToAutoClose}
              onChange={e =>
                setBody(prevBody => ({
                  ...prevBody,
                  daysToAutoClose: e.target.value
                }))
              }
            />
            <Form.Text className="text-muted">
              Defina quantos dias corridos são necessários para fechar o ticket.
            </Form.Text>
          </Form.Group>

          {/** HANDLE ACTION ON COMPLETED LATE REPLY */}
          <h5 className="fw-semi-bold">Resposta tardia do solicitante</h5>
          <Form.Group
            className="mb-3"
            controlId="serviceGroup.actionOnCompletedReply"
          >
            <Form.Label>
              Quando um solicitante responder a um ticket com status{' '}
              <Badge bg="dark" className="text-white">
                Concluído
              </Badge>{' '}
              <span className="text-danger">*</span>
            </Form.Label>
            <Form.Check
              type="radio"
              label="Reabrir o ticket"
              value="REOPEN"
              checked={body.actionOnCompletedReply === 'REOPEN'}
              onChange={e =>
                setBody(prevBody => ({
                  ...prevBody,
                  actionOnCompletedReply: e.target.value
                }))
              }
            />
            <Form.Check
              type="radio"
              label="Criar novo ticket"
              value="CREATE_NEW_TICKET"
              checked={body.actionOnCompletedReply === 'CREATE_NEW_TICKET'}
              onChange={e =>
                setBody(prevBody => ({
                  ...prevBody,
                  actionOnCompletedReply: e.target.value
                }))
              }
            />
            <Form.Check
              type="radio"
              label="Enviar notificação de Ticket Encerrado"
              value="SEND_TEMPLATE_EMAIL"
              checked={body.actionOnCompletedReply === 'SEND_TEMPLATE_EMAIL'}
              onChange={e =>
                setBody(prevBody => ({
                  ...prevBody,
                  actionOnCompletedReply: e.target.value
                }))
              }
            />
          </Form.Group>

          {/** HANDLE LATE ACTION ON CLOSED REPLY */}
          <Form.Group
            className="mb-3"
            controlId="serviceGroup.actionOnClosedReply"
          >
            <Form.Label>
              Quando um solicitante responder a um ticket com status{' '}
              <Badge bg="secondary">Fechado</Badge>{' '}
              <span className="text-danger">*</span>
            </Form.Label>
            <Form.Check
              type="radio"
              label="Criar novo ticket"
              value="CREATE_NEW_TICKET"
              checked={body.actionOnClosedReply === 'CREATE_NEW_TICKET'}
              onChange={e =>
                setBody(prevBody => ({
                  ...prevBody,
                  actionOnClosedReply: e.target.value
                }))
              }
            />
            <Form.Check
              type="radio"
              label="Enviar notificação de Ticket Encerrado"
              value="SEND_TEMPLATE_EMAIL"
              checked={body.actionOnClosedReply === 'SEND_TEMPLATE_EMAIL'}
              onChange={e =>
                setBody(prevBody => ({
                  ...prevBody,
                  actionOnClosedReply: e.target.value
                }))
              }
            />

            <Form.Control.Feedback>Muito bom!</Form.Control.Feedback>
            <Form.Control.Feedback type="invalid">
              Escolha uma opção!
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="falcon-default" onClick={handleClose}>
          Fechar
        </Button>
        <Button variant="primary" onClick={onSubmit}>
          <FontAwesomeIcon icon={faSave} className="me-2" />
          Salvar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ServiceGroupRegistrationModal;
